<template>
	<div>
		<el-dialog :visible.sync="showbatchupdate" :title="title" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div class="batchupdatewin">
			<el-card class="box-card" label="" shadow="hover" style="margin-top:-20px" v-if="!isshowSelectItem">
				<div slot="header" class="clearfix">
					<span>收货地址</span>
					<el-button type="warning" size="mini" style="margin-left:30px" @click="copyaddress">一键复制</el-button>
				</div>
				<el-form ref="form" :model="address" label-width="80px" size="mini">
					<el-form-item label="收件人">
						<span>{{ address.name }}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{ address.phone }}</span>
					</el-form-item>
					<el-form-item label="收货地址">
						<span v-if="ischina">{{ address.province }} {{ address.city }} {{ address.district }} {{ address.detailaddr }}</span>
						<span else>{{ address.postcode }}, {{ address.detailaddr }}{{ address.street }}{{ address.district }}, {{ address.city }}, {{ address.province }}</span>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card" label="" shadow="hover" v-if="!isshowSelectItem">
				<div slot="header" class="clearfix"><span>发货信息</span></div>
				<el-form ref="form" :model="express" label-width="80px" size="mini">
					<el-form-item label="快递单号"><el-input v-model="express.expressid_gn"></el-input></el-form-item>
				</el-form>
			</el-card>
			<el-form ref="form" :model="express" label-width="90px" size="mini" v-if="isshowSelectItem">
				<el-form-item label="设置更新项">
					<el-select v-model="typename" @change="changetype" style="width:100%">
						<el-option v-for="(item, index) in typelist" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
					<div style="color:#f1a664;font-size:11pt;">
						<span>{{ remarktips }}</span>
					</div>
				</el-form-item>

				<el-form-item :label="item.label" v-for="(item, index) in checkedcol" :key="index">
					<el-date-picker
						v-if="item.type == 'time'"
						v-model="item.val"
						style="width:100%"
						type="datetime"
						format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择操作时间"
					></el-date-picker>
					<el-select v-else-if="item.type == 'select'" v-model="item.val" style="width:100%">
						<el-option v-for="i in item.source" :key="i.label" :label="i.label" :value="i.label"></el-option>
					</el-select>
					<el-input v-else-if="item.type=='text'" v-model="item.val" style="width:100%"></el-input>
					<span v-else-if="item.type=='span'">{{item.value}}</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="padding-top:0px">
				<div style="text-align: center;">
					<el-button type="success" size="mini" @click="BatchUpdate">确 定</el-button>
					<el-button @click="cancel" size="mini">取 消</el-button>
				</div>
			</span>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			address: {
				name: '',
				phone: '',
				province: '',
				city: '',
				district: '',
				street: '',
				detailaddr: '',
				postcode: ''
			},
			express: {
				expressid_gn: ''
			},
			typename: '',
			typeindex: 0,
			typelist: [],
			ischina: false,
			showbatchupdate: false,
			title: '',
			pkcol: '',
			isshowSelectItem: true,
			checkedcol: [],
			pageparam: {},
			pkval: '',
			batch: '',
			isgrid: false,
			searchinfo: '',
			divclass: 'batchupdatewin',
			remarktips: '',
			tablename: '',
			alltypelist:[
				{ id: 0, name: '提单号', type: '更新', tablename: 'sp_pt_printlist', updatecol: [{ col: 'p_airwaybill', val: '', label: '提单号', type: 'text' },{ col: 'flightnum', val: '', label: '班号', type: 'text' }] },
				{
					id: 1,
					name: '更新状态',
					type: '更新状态',
					remark: '如果需要同步生成物流，则可填写操作时间和操作描述',
					tablename: 'sp_pt_printlist',
					updatecol: [
						{
							col: 'p_orderstate',
							val: '',
							postfix:'',
							label: '订单状态',
							type: 'select',
							source: [
								// { label: '未打印',postfix:'wsh' }, { label: '未申报',postfix:'sh' }, { label: '已申报',postfix:'dy' },{ label: '已放行' ,postfix:'dy'}, { label: '查验' ,postfix:'dy'}, { label: '扣关',postfix:'dy' }, { label: '短装',postfix:'dy' }, { label: '退运',postfix:'dy' }
								]
						},
						{ col: 'createtime', val: '', label: '操作时间', type: 'time' },
						{ col: 'context', val: '', label: '操作描述', type: 'text' }
					]
				},
				{
					id: 2,
					name: '快递信息',
					type: '更新',
					tablename: 'sp_pt_express',
					updatecol: [{ col: 'expresscom', val: '', label: '快递公司', type: 'text' }, { col: 'expressid', val: '', label: '快递单号', type: 'text' }]
				},
				{
					id: 3,
					name: '生成物流',
					type: '生成物流',
					updatecol: [{ col: 'createtime', val: '', label: '操作时间', type: 'time' }, { col: 'context', val: '', label: '操作描述', type: 'text' }]
				},
				{ id: 4, name: '袋号', type: '更新', tablename: 'sp_pt_printlist', updatecol: [{ col: 'p_bagid', val: '', label: '袋号', type: 'text' }] },
				{ id: 5, name: '经停城市', type: '更新', tablename: 'sp_pt_address', updatecol: [{ col: 'transcity', val: '', label: '经停城市', type: 'text' }] }
				// ,
				// { id: 5, name: '反申报', type: '反申报', tablename: 'sp_pt_printlist' ,updatecol:[{col:'p_orderstate',val:'',label:'申报状态',type:'span'}] },
				// { id: 6, name: '申报', type: '申报', tablename: 'sp_pt_printlist',updatecol:[{col:'p_orderstate',val:'已申报',label:'申报状态',type:'span'}] },
				],
				statelist:[]
		};
	},
	mounted() {},
	methods: {
		init(param) {
			//debugger
			//param.title='生成物流';
			this.pkval = '';
			this.batch = '';
			this.pkcol = '';
			this.isgrid = false;
			this.typename = '';
			this.searchinfo = '';
			this.type = '';
			this.tablename = '';
			this.checkedcol =[];
			this.typelist=JSON.parse(JSON.stringify(this.alltypelist));
			this.title = param.title;
			this.pkval = param.pkval;
			this.batch = param.batch;
			this.pkcol = param.pkcol;
			this.pageparam = param.pageparam;

			this.isgrid = param.isgrid;
			if (param.searchinfo != undefined) this.searchinfo = param.searchinfo;
			if (param.title == '自行邮寄') {
				this.showbatchupdate = true;
				this.isshowSelectItem = false;
				this.GetShop();
			} else {
				var list = this.typelist.filter(function(e) {
					return e.name == param.title;
				});
				if (list.length > 0) {
					this.checkedcol = list[0].updatecol;
					this.typename = param.title;
					this.remarktips = list[0].remark;
					this.type = list[0].type;
					this.tablename = list[0].tablename;
					this.typelist = list;
				} else {
					this.typelist.splice(1, 1);
				}
				if (this.typelist.length > 0) {
					if (this.type == '申报' || this.type == '反申报') {
						this.showbatchupdate = false;
						this.BatchUpdate();
					} else {
						if(this.typelist[0].type=='更新状态'){
							//加载状态
							this.getorderstate();
						}
						else
							this.showbatchupdate = true;
					}
				}
			}
		},
		getorderstate(){
			var that = this;
			this.$apipost.get.dic({ type: '订单状态' }).then(res => {
				if (res.list != undefined) {
					//debugger
					that.statelist=res.list;
					that.typelist[0].updatecol[0].source=that.statelist;
					that.checkedcol=that.typelist[0].updatecol;
					that.showbatchupdate = true;
				}
			});
		},
		//下拉选项改变
		changetype(value) {
			var checkedlist = this.typelist.filter(function(e) {
				return e.name == value;
			});
			if (checkedlist.length > 0) {
				this.checkedcol = checkedlist[0].updatecol;
				this.type = checkedlist[0].type;
				this.remarktips = checkedlist[0].remark;
				this.tablename = checkedlist[0].tablename;
			} else {
				this.checkedcol = [];
				this.remarktips = '';
				this.tablename = '';
				this.type = '';
			}
		},
		GetShop() {
			var that = this;
			this.$apipost.get.GetShopByUser().then(res => {
				if (res.info != '') {
					that.address = res.info;
				}
			});
		},
		BatchUpdate() {
			if (!this.isshowSelectItem) {
				tablename = 'sp_pt_printlist';
				this.checkedcol = [{ val: this.express.expressid_gn, col: 'expressid_gn' }];
			}
			var col=JSON.parse(JSON.stringify(this.checkedcol));
			//debugger
			col.forEach(e=>{
				if(e.col=="p_orderstate"&&e.type=='select')
				{
					e.source.forEach(b=>{
						if(e.val==b.label)
						{
							e.val=b.remark;//更新订单状态 p_orderstate
							e.postfix=b.value; //转换订单表
							return false;
						}
					});
					return false;
				}
			});
			var paraminfo = {
				batch: this.batch,
				pkval: this.pkval,
				pageparam: this.pageparam,
				updatecol: col,
				tablename: this.tablename,
				type: this.type,
				pkcol: this.pkcol,
				searchinfo: this.searchinfo,
				userid: localStorage.getItem('userid')
			};
			// console.log('更新', encodeURIComponent(JSON.stringify(paraminfo)));
			// return false;
			//debugger
			this.$tool.loading('正在更新', this.divclass);
			this.$apipost.post.BatchUpdate({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
					this.cancel();
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		cancel() {
			this.showbatchupdate = false;
			if (!this.isgrid) this.$parent.showsuccesswin = true;
			else this.$parent.refreshgrid(true);
		},
		copyaddress() {
			let oInput = document.createElement('textarea');
			oInput.value = '收件人：' + this.address.name + '\n联系电话：' + this.address.phone + '\n收货地址：';
			if (!this.ischina)
				oInput.value =
					oInput.value +
					this.address.postcode +
					',' +
					this.address.detailaddr +
					this.address.street +
					this.address.district +
					',' +
					this.address.city +
					',' +
					this.address.province;
			else oInput.value = oInput.value + this.address.province + this.address.city + this.address.district + this.address.detailaddr;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象
			document.execCommand('Copy'); // 执行浏览器复制命令
			this.$message({
				message: '复制成功',
				type: 'success',
				duration: 1000
			});
			oInput.remove();
		}
	}
};
</script>
<style></style>
